import isNil from 'lodash/isNil';
import compact from 'lodash/compact';
import get from 'lodash/get';

import { makeYoutubeSource, makeStandardMpegSource } from 'zoomforth_component_lib/videoish_player.jsx';

export const makeVideoishPlayerSourcesForAsset = (assetData)=> {

  if (isNil(assetData)) {
    return {};
  }

  return assetData.youtubeId ?
  [
    makeYoutubeSource(assetData.youtubeId)
  ]
    :
    compact([
      makeStandardMpegSource(assetData.streams.mpeg4, 'HD'),
      assetData.streams.lowQuality && 
        makeStandardMpegSource(assetData.streams.lowQuality, 'Low')
    ]);
};

const _makeVideoishPlayerPropsForAsset = (assetData)=>
  ({
    sources: makeVideoishPlayerSourcesForAsset(assetData),
    subtitleTrack: assetData.subtitles,
    id: `${assetData.assetType}-${assetData.assetId}`,
    'data-asset-ident': `${assetData.assetType}-${assetData.assetId}`
  });


export const makeVideoishPlayerPropsForAsset = (assetData)=>
  ({
    ..._makeVideoishPlayerPropsForAsset(assetData),
    posterImageUrl: assetData.displayImage
  });


export const makeVideoishPlayerPropsForContent = (contentItem, assetData)=> {
  let posterImageUrl = null;
  if (contentItem.tile_display_image) {
    posterImageUrl = contentItem.tile_display_image;
  } else if (assetData){
    posterImageUrl = assetData.displayImage;
  }
  const props = _makeVideoishPlayerPropsForAsset(assetData);
  return { 
    ...props,
    posterImageUrl,
    'data-content-uuid': contentItem.uuid,
    id: `${props.id}-${contentItem.uuid}`,
    canDownloadVideo: get(contentItem, 'can_download_asset', true)
  };
};
